import { gql } from "@apollo/client";

export const CreateAsset = gql`
    mutation CreateAsset ($input: CreateAssetInput!){
        createAsset(asset: $input){
            id
            urn
            serialNumber
            product {
                id
                urn
                name
                productCode
            }
            manufacturer {
                id
                urn
                name
            }
        }
    }
`;
